export const shouldForwardProp = (propName: string) => !propName.startsWith('$');
